class MultiQuantityValidator {
    constructor() {
        this.maxTotal = this.getLimitFromDOM();
        this.init();
    }

    getLimitFromDOM() {
        const limitElement = document.querySelector('[name="properties[Choice limit]"]');
        if (limitElement) {
            return parseInt(limitElement.value);
        }
        throw new Error('No .hulk-limit element found. Please add one to set the quantity limit.');
    }

    init() {
        this.addEventListeners();
        this.addTotalDisplay();
    }

    addEventListeners() {
        const container = document.querySelector('.hulk_multi_qty_main');
        
        container.addEventListener('click', (e) => {
            if (e.target.classList.contains('hulk_quantity_button')) {
                setTimeout(() => this.validateTotal(e.target), 10);
            }
        });

        container.addEventListener('input', (e) => {
            if (e.target.classList.contains('hulk_quantity_amount')) {
                this.validateTotal(e.target);
            }
        });

        container.addEventListener('change', (e) => {
            if (e.target.classList.contains('hulk_quantity_amount')) {
                this.validateTotal(e.target);
            }
        });
    }

    getCurrentTotal() {
        const inputs = document.querySelectorAll('.hulk_quantity_amount');
        return Array.from(inputs).reduce((total, input) => {
            return total + (parseInt(input.value) || 0);
        }, 0);
    }

    validateTotal(triggerElement) {
        const currentTotal = this.getCurrentTotal();
        const inputs = document.querySelectorAll('.hulk_quantity_amount');
        const incrementButtons = document.querySelectorAll('[data-htype="increment"]');
        
        this.updateTotalDisplay(currentTotal);

        if (currentTotal >= this.maxTotal) {
            incrementButtons.forEach(btn => {
                btn.disabled = true;
                btn.classList.add('disabled');
            });
            
            this.showLimitMessage();
            
            if (currentTotal > this.maxTotal && triggerElement?.classList.contains('hulk_quantity_amount')) {
                const excess = currentTotal - this.maxTotal;
                const currentValue = parseInt(triggerElement.value) || 0;
                triggerElement.value = Math.max(0, currentValue - excess);
                this.updateHiddenInputs();
            }
        } else {
            incrementButtons.forEach((btn, index) => {
                const input = inputs[index];
                const currentValue = parseInt(input.value) || 0;
                const maxForThis = parseInt(input.getAttribute('data-max')) || Infinity;
                
                if (currentValue < maxForThis) {
                    btn.disabled = false;
                    btn.classList.remove('disabled');
                }
            });
            
            this.hideLimitMessage();
        }

        this.updateHiddenInputs();
    }

    addTotalDisplay() {
        const container = document.querySelector('.hulk_multi_qty_main');
        const totalDisplay = document.createElement('div');
        totalDisplay.className = 'total-quantity-display';
        totalDisplay.innerHTML = `
            <div>
                Total Selected: <span id="current-total">0</span> / ${this.maxTotal}
            </div>
            <div id="limit-message" style="display: none;">
                Maximum ${this.maxTotal} items allowed across all sizes
            </div>
        `;
        container.appendChild(totalDisplay);
        this.addProgressBar();
    }

    addProgressBar() {
        const totalDisplay = document.querySelector('.total-quantity-display');
        const progressBar = document.createElement('div');
        progressBar.innerHTML = `
            <div style="margin-top: 10px;">
                <div style="
                    background: #e9ecef;
                    height: 6px;
                    border-radius: 3px;
                    overflow: hidden;
                ">
                    <div id="quantity-progress" style="
                        height: 100%;
                        background: linear-gradient(90deg, #28a745, #ffc107, #dc3545);
                        width: 0%;
                        transition: width 0.3s ease;
                    "></div>
                </div>
            </div>
        `;
        totalDisplay.appendChild(progressBar);
    }

    updateTotalDisplay(total) {
        const display = document.getElementById('current-total');
        if (display) {
            display.textContent = total;
            
            display.style.transition = 'transform 0.2s ease';
            display.style.transform = 'scale(1.1)';
            setTimeout(() => {
                display.style.transform = 'scale(1)';
            }, 200);
        }
        
        const progressBar = document.getElementById('quantity-progress');
        if (progressBar) {
            const percentage = (total / this.maxTotal) * 100;
            progressBar.style.width = `${Math.min(percentage, 100)}%`;
        }
    }

    showLimitMessage() {
        const message = document.getElementById('limit-message');
        if (message) {
            message.style.display = 'block';
        }
    }

    hideLimitMessage() {
        const message = document.getElementById('limit-message');
        if (message) {
            message.style.display = 'none';
        }
    }

    updateHiddenInputs() {
        const inputs = document.querySelectorAll('.hulk_quantity_amount');
        const selections = [];
        const inventoryRecord = [];

        inputs.forEach(input => {
            const value = parseInt(input.value) || 0;
            const size = input.getAttribute('data-conditional-value');
            const maxQty = input.getAttribute('data-qval');
            
            if (value > 0) {
                selections.push(`${size} | ${value}`);
            }
            inventoryRecord.push(`${size}_hin_${maxQty}`);
        });

        const hiddenMultiQty = document.querySelector('.hulk_mutli_qty');
        const hiddenUniqueProps = document.querySelector('[data-unique_prop_name="_hin_Size Mix_hin_Size"]'); // adjustable and depending on the name of the option (in this case it was "Size")
        
        if (hiddenMultiQty) {
            hiddenMultiQty.value = selections.join(' , ');
        }
        
        if (hiddenUniqueProps) {
            hiddenUniqueProps.setAttribute('data-inventory-record', inventoryRecord.join(','));
        }
    }

    resetAll() {
        const inputs = document.querySelectorAll('.hulk_quantity_amount');
        inputs.forEach(input => input.value = 0);
        this.validateTotal();
    }
}

window.addEventListener("load", (event) => {
    const validator = new MultiQuantityValidator();
});